<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.application')"
    resource="applications"
    :onFormSubmit="handleSubmit"
    :actionButtons="['show', 'edit']"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/applications.js';
import _ from 'lodash';

@Component
export default class Application extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'wechat_application_appid_cont',
      'name_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    const array = [
      // {
      //   key: 'wechat_application.appid',
      //   label: 'AppID',
      //   width: 150
      // },
      'name',
      // 'logo',
      // type === 'show' && 'share_desc',
      // type === 'show' && 'share_image',
      // type === 'show' && 'poster_image',
      {
        key: 'monthly_report_receivers',
        renderCell: (h, { props: { value } }) => {
          return _.map(value, (item) => {
            return <div>{ item }</div>
          })
        }
      },
      {
        key: 'purple_shop_ids',
        renderCell: (h, { props: { value } }) => {
          return _.map(value, (item) => {
            return <div>{ item }</div>
          })
        }
      },
      {
        key: 'leaderboard_scroll_interval',
        renderCell: (h, { props: { value } }) => {
          return <span>{value || '-'}秒</span>
        }
      },
      {
        key: 'custom_shop_ids',
        renderCell: (h, { props: { value } }) => {
          return _.map(value, (item) => {
            return <div>{ item }</div>
          })
        }
      },
      {
        key: 'date_excluded_shop_ids',
        renderCell: (h, { props: { value } }) => {
          return _.map(value, (item) => {
            return <div>{ item }</div>
          })
        }
      },
      {
        key: 'date_excluded_cutoff_date',
        renderCell: (h, { props: { value } }) => {
          return <span>{value || '-'}</span>
        }
      },
      {
        key: 'feng_pei_shan_user_id',
        renderCell: (h, { props: { value } }) => {
          return <span>{value || '-'}</span>
        }
      },
      {
        key: 'feng_pei_shan_shop_ids',
        renderCell: (h, { props: { value } }) => {
          return _.map(value, (item) => {
            return <div>{ item }</div>
          })
        }
      },
      {
        key: 'deng_zheng_yao_user_id',
        renderCell: (h, { props: { value } }) => {
          return <span>{value || '-'}</span>
        }
      },
      {
        key: 'deng_zheng_yao_shop_ids',
        renderCell: (h, { props: { value } }) => {
          return _.map(value, (item) => {
            return <div>{ item }</div>
          })
        }
      },
      {
        key: 'luo_xing_yi_user_id',
        renderCell: (h, { props: { value } }) => {
          return <span>{value || '-'}</span>
        }
      },
      // 公海流转池可配置阈值
      {
        key: 'team_leader_customer_limit',
        renderCell: (h, { props: { value } }) => <span>{value || '150（默认）'}</span>
      },
      {
        key: 'team_member_customer_limit',
        renderCell: (h, { props: { value } }) => <span>{value || '200（默认）'}</span>
      },
      {
        key: 'customer_pool_open_days',
        renderCell: (h, { props: { value } }) => {
          return (value && value.length) ? _.map(value, (item) => <div>{ item }</div>) : <span>15, 30（默认）</span>
        }
      },
      {
        key: 'customer_pool_open_from_hour',
        renderCell: (h, { props: { value } }) => <span>{value || value === 0 ? value : '10（默认）'}</span>
      },
      {
        key: 'customer_pool_open_to_hour',
        renderCell: (h, { props: { value } }) => <span>{value || value === 0 ? value : '20（默认）'}</span>
      },
      {
        key: 'customer_pool_daily_claim_limit',
        renderCell: (h, { props: { value } }) => <span>{value || '5（默认）'}</span>
      },
      {
        key: 'customer_pool_ownership_restriction_months',
        renderCell: (h, { props: { value } }) => <span>{value || '3（默认）'}</span>
      },
      {
        key: 'customer_pool_followup_hours',
        renderCell: (h, { props: { value } }) => <span>{value || '48（默认）'}</span>
      },
      {
        key: 'customer_pool_followup_warning_lead_hours',
        renderCell: (h, { props: { value } }) => <span>{value || '6（默认）'}</span>
      },
      {
        key: 'customer_pool_new_record_no_follow_days',
        renderCell: (h, { props: { value } }) => <span>{value || '7（默认）'}</span>
      },
      {
        key: 'customer_pool_new_customer_no_follow_days',
        renderCell: (h, { props: { value } }) => <span>{value || '30（默认）'}</span>
      },
      {
        key: 'customer_pool_new_customer_no_order_days',
        renderCell: (h, { props: { value } }) => <span>{value || '90（默认）'}</span>
      },
      {
        key: 'customer_pool_old_customer_no_follow_days',
        renderCell: (h, { props: { value } }) => <span>{value || '90（默认）'}</span>
      },
      {
        key: 'customer_pool_old_customer_no_repurchase_days',
        renderCell: (h, { props: { value } }) => <span>{value || '365（默认）'}</span>
      },
      {
        key: 'customer_pool_capacity_warning_ratio',
        renderCell: (h, { props: { value } }) => <span>{value || '0.9（默认）'}</span>
      },
      {
        key: 'customer_pool_release_warning_lead_days',
        renderCell: (h, { props: { value } }) => {
          return (value && value.length) ? _.map(value, (item) => <div>{ item }</div>) : <span>3, 1（默认）</span>
        }
      },
      'created_at',
      'updated_at'
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      {
        key: 'monthly_report_receivers',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            filterable: true
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        key: 'purple_shop_ids',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            filterable: true
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        key: 'leaderboard_scroll_interval',
        renderCell: {
          component: 'input',
          props: {
            type: 'number',
            min: 1,
            placeholder: '60'
          },
          domProps: {
            style: 'width: 100%'
          },
          hint: '大屏滚动间隔时间，单位：秒，默认60秒'
        }
      },
      {
        key: 'custom_shop_ids',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            filterable: true
          },
          domProps: {
            style: 'width: 100%'
          },
          hint: '定制业务店铺ID列表'
        }
      },
      {
        key: 'date_excluded_shop_ids',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            filterable: true
          },
          domProps: {
            style: 'width: 100%'
          },
          hint: '日期过滤店铺ID列表（只统计指定日期之前的订单）'
        }
      },
      {
        key: 'date_excluded_cutoff_date',
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          },
          hint: '日期过滤截止时间（此时间及之后下单的订单不参与业绩计算）'
        }
      },
      {
        key: 'feng_pei_shan_user_id',
        renderCell: {
          component: 'input',
          props: {
            type: 'number',
            min: 1,
            placeholder: '9'
          },
          domProps: {
            style: 'width: 100%'
          },
          hint: '冯佩珊业绩用户ID'
        }
      },
      {
        key: 'feng_pei_shan_shop_ids',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            filterable: true
          },
          domProps: {
            style: 'width: 100%'
          },
          hint: '冯佩珊业绩档口店铺ID列表'
        }
      },
      {
        key: 'deng_zheng_yao_user_id',
        renderCell: {
          component: 'input',
          props: {
            type: 'number',
            min: 1,
            placeholder: '4'
          },
          domProps: {
            style: 'width: 100%'
          },
          hint: '邓正瑶业绩用户ID'
        }
      },
      {
        key: 'deng_zheng_yao_shop_ids',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            filterable: true
          },
          domProps: {
            style: 'width: 100%'
          },
          hint: '邓正瑶业绩档口店铺ID列表'
        }
      },
      {
        key: 'luo_xing_yi_user_id',
        renderCell: {
          component: 'input',
          props: {
            type: 'number',
            min: 1,
            placeholder: '14'
          },
          domProps: {
            style: 'width: 100%'
          },
          hint: '骦幸仪用户ID（用于紫队业绩计算）'
        }
      },
      // 公海流转池可配置阈值（留空回退默认值）
      {
        key: 'team_leader_customer_limit',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 0, placeholder: '150' },
          domProps: { style: 'width: 100%' }
        }
      },
      {
        key: 'team_member_customer_limit',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 0, placeholder: '200' },
          domProps: { style: 'width: 100%' }
        }
      },
      {
        key: 'customer_pool_open_days',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            filterable: true
          },
          domProps: { style: 'width: 100%' },
          hint: '流转池开放日（每月几号，可多选），默认 15、30'
        }
      },
      {
        key: 'customer_pool_open_from_hour',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 0, max: 23, placeholder: '10' },
          domProps: { style: 'width: 100%' },
          hint: '开放起始小时（含），默认 10。测试可设 0'
        }
      },
      {
        key: 'customer_pool_open_to_hour',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 1, max: 24, placeholder: '20' },
          domProps: { style: 'width: 100%' },
          hint: '开放结束小时（不含），默认 20。测试可设 24'
        }
      },
      {
        key: 'customer_pool_daily_claim_limit',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 1, placeholder: '5' },
          domProps: { style: 'width: 100%' },
          hint: '每人每开放日最多认领数，默认 5'
        }
      },
      {
        key: 'customer_pool_ownership_restriction_months',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 0, placeholder: '3' },
          domProps: { style: 'width: 100%' },
          hint: '原归属人 N 个月内不可再认领，默认 3。测试可设 0'
        }
      },
      {
        key: 'customer_pool_followup_hours',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 1, placeholder: '48' },
          domProps: { style: 'width: 100%' },
          hint: '认领后首次有效跟进期限（小时），默认 48。测试可调小'
        }
      },
      {
        key: 'customer_pool_followup_warning_lead_hours',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 0, placeholder: '6' },
          domProps: { style: 'width: 100%' },
          hint: '首跟到期前 N 小时预警，默认 6'
        }
      },
      {
        key: 'customer_pool_new_record_no_follow_days',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 1, placeholder: '7' },
          domProps: { style: 'width: 100%' },
          hint: '新录入 N 天无有效跟进释放，默认 7'
        }
      },
      {
        key: 'customer_pool_new_customer_no_follow_days',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 1, placeholder: '30' },
          domProps: { style: 'width: 100%' },
          hint: '新客 N 天无有效跟进释放，默认 30'
        }
      },
      {
        key: 'customer_pool_new_customer_no_order_days',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 1, placeholder: '90' },
          domProps: { style: 'width: 100%' },
          hint: '新客 N 天无成交释放，默认 90'
        }
      },
      {
        key: 'customer_pool_old_customer_no_follow_days',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 1, placeholder: '90' },
          domProps: { style: 'width: 100%' },
          hint: '老客 N 天无有效跟进，默认 90'
        }
      },
      {
        key: 'customer_pool_old_customer_no_repurchase_days',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 1, placeholder: '365' },
          domProps: { style: 'width: 100%' },
          hint: '老客最近下单后 N 天无复购，默认 365'
        }
      },
      {
        key: 'customer_pool_release_warning_lead_days',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            filterable: true
          },
          domProps: { style: 'width: 100%' },
          hint: '释放预警提前天数档位（可多档，按天，留空回退默认 3、1）'
        }
      },
      {
        key: 'customer_pool_capacity_warning_ratio',
        renderCell: {
          component: 'input',
          props: { type: 'number', min: 0, max: 1, step: 0.1, placeholder: '0.9' },
          domProps: { style: 'width: 100%' },
          hint: '容量预警阈值（0-1），默认 0.9'
        }
      }
      // {
      //   key: 'logo',
      //   renderCell: {
      //     hint: `${this.$t('suggestSize')}: 150x150`,
      //     props: {
      //       cropper: {
      //         width: 150,
      //         height: 150
      //       }
      //     }
      //   }
      // },
      // {
      //   key: 'share_desc',
      //   renderCell: {
      //     hint: this.$t('hint.shareDescLengthHint'),
      //   }
      // },
      // {
      //   key: 'share_image',
      //   renderCell: {
      //     hint: `${this.$t('suggestSize')}: 500x400`,
      //     props: {
      //       cropper: {
      //         width: 500,
      //         height: 400
      //       }
      //     }
      //   }
      // },
      // {
      //   key: 'poster_image',
      //   renderCell: {
      //     hint: `${this.$t('suggestSize')}: 600x509`,
      //     props: {
      //       cropper: {
      //         width: 600,
      //         height: 509
      //       }
      //     }
      //   }
      // },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    const env = process.env.VUE_APP_ENV
    const wechat_application = row.wechat_application
    let canSubmitAudit = false
    let canRelease = false
    let canMockSubmitAudit = false
    let canMockRelease = false

    if (wechat_application) {
      if (wechat_application.trial_submition) {
        if (env === 'development') {
          canMockSubmitAudit = !wechat_application.audit_submition || (wechat_application.audit_submition.state !== 'pending' && wechat_application.audit_submition.state !== 'delay')
        } else {
          canSubmitAudit = !wechat_application.audit_submition || (wechat_application.audit_submition.state !== 'pending' && wechat_application.audit_submition.state !== 'delay')
        }
      }

      if (wechat_application.audit_submition) {
        if (env === 'development') {
          canMockRelease = wechat_application.audit_submition.state === 'success'
        } else {
          canRelease = wechat_application.audit_submition.state === 'success'
        }
      }
    }

    const handleSubmitAudit = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/submit_audit`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleMockSubmitAudit = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_submit_audit`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleRelease = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/release`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleMockRelease = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_release`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    //const handleBindWechat = async (isBinded) => {
    //  if (isBinded) {
    //    const { url } = await this.$request.get('wechat_third_party_platform/base/component_auth_url');
    //     window.location = url;
    //  } else {
    //    this.$router.push({ name: 'bind_exists_mini_program' });
    //  }
    //}

    const expiredAtForm = [
      {
        prop: 'expired_at',
        label: this.$t('application.expiredAt'),
        renderCell: {
          component: 'dateTimePicker',
        }
      }
    ]
    const handleSubmitExpiredAtForm = async (value) => {
      await this.$autoLoading(this.$request.put(`/applications/${row.id}/update_expired_at`, value));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'applications.edit', params: { id: row.id } }
        }
      },
      canSubmitAudit && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.submitAudit'),
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleSubmitAudit(row.wechat_application_id)
        }
      },
      canMockSubmitAudit && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.simulateSubmitAudit'),
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleMockSubmitAudit(row.wechat_application_id)
        }
      },
      canRelease && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.release'),
          type: 'primary',
          can: 'wtpp_applications.release'
        },
        on: {
          confirm: () => handleRelease(row.wechat_application_id)
        }
      },
      canMockRelease && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.simulateRelease'),
          type: 'primary',
          can: 'wtpp_applications.release'
        },
        on: {
          confirm: () => handleMockRelease(row.wechat_application_id)
        }
      },
      //{
      //  functional: true,
      //  render: () => {
      //    const isBinded = _.get(row, 'wechat_application.id');
      //    return <el-button type="primary" size="mini" onClick={() => handleBindWechat(isBinded)}>{ isBinded ? this.$t('application.actions.reauthorization') : this.$t('application.actions.bindMiniProgram') }</el-button>
      //  }
      //},
      {
        component: 'dialogFormButton',
        props: {
          label: this.$t('application.actions.updateExpiredAt'),
          columns: expiredAtForm,
          value: row,
          can: 'applications.update_expired_at',
          submitHandler: handleSubmitExpiredAtForm
        }
      }
    ].filter(Boolean);
  }

  async handleSubmit({ data, type, resource, namespace }) {
    if (type === 'new') {
      const response = await this.$request.post(`/${namespace}${resource}`, data);
      this.$message.success(this.$t('bean.createSuccess'));
      localStorage.setItem('currentRoleId', response.application_admin_users_role_id);
      this.$router.push({ name: 'home' });
      location.reload();
    } else {
      await this.$request.put(`/${namespace}${resource}/${data.id}`, data);
      this.$message.success(this.$t('bean.updateSuccess'));
      this.$router.push({ name: `${resource}.show`, params: { id: data.id } });
    }
  }
}

export const route = [
  {
    path: '/applications',
    name: 'applications.index',
    component: Application,
    props: {
      type: 'index',
    }
  },
  {
    path: '/applications/new',
    name: 'applications.new',
    component: Application,
    props: {
      type: 'new',
    }
  },
  {
    path: '/applications/:id',
    name: 'applications.show',
    component: Application,
    props: {
      type: 'show',
    }
  },
  {
    path: '/applications/:id/edit',
    name: 'applications.edit',
    component: Application,
    props: {
      type: 'edit'
    }
  }
]
</script>
